import React from 'react'
import styles from './styles.module.css'

export const HeroTitleLineBreak = () => <br className={styles.newLine} />

export const defaultHeroTitle: React.ReactNode = (
  <h1>
    <span>Banking for </span>
    <HeroTitleLineBreak />
    <span>what you’re building</span>
  </h1>
)

export const defaultHeroSubtitle: React.ReactNode = `Startups of all sizes rely on Mercury as they create the next great
companies. Apply in 10 minutes to try business banking as it should be.`
